/* eslint-disable @typescript-eslint/no-explicit-any */
import { CnpjNormalizer, CnpjValidator } from '@querodelivery/next-cnpj';
import { removeNoNumericValues } from './transform';
import { removeNoNumeric } from '@/Utils/FnUtils';

export function pluralByQuantity(text: string, quantity: number) {
  if (quantity <= 1) return text;

  if (text.endsWith('m')) return `${text.slice(0, -1)}ns`;

  return `${text}s`;
}

export const validateCpf = (cpf: string) => {
  if (cpf === null || cpf === undefined) return false;
  cpf = removeNoNumericValues(cpf) as string;
  let numeros: any;
  let digitos: any;
  let soma;
  let i;
  let resultado: any;
  let digitos_iguais;
  digitos_iguais = 1;
  if (cpf.length < 11) return 'CPF inválido';
  for (i = 0; i < cpf.length - 1; i++)
    if (cpf.charAt(i) != cpf.charAt(i + 1)) {
      digitos_iguais = 0;
      break;
    }
  if (!digitos_iguais) {
    numeros = cpf.substring(0, 9);
    digitos = cpf.substring(9);
    soma = 0;
    for (i = 10; i > 1; i--) soma += numeros.charAt(10 - i) * i;
    resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
    if (resultado != digitos.charAt(0)) return 'CPF inválido';
    numeros = cpf.substring(0, 10);
    soma = 0;
    for (i = 11; i > 1; i--) soma += numeros.charAt(11 - i) * i;
    resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
    if (resultado != digitos.charAt(1)) return 'CPF inválido';
    return undefined;
  }
  return undefined;
};

const cnpjValidator = new CnpjValidator();

export function validateCnpj(cnpj: string): string | undefined {
  const result = cnpjValidator.validate(cnpj ?? '');
  if (result.isValid) {
    return undefined;
  }
  return result.errorMessage ?? 'CNPJ inválido';
}

export function normalizeCnpj(cnpj: string | null | undefined): string {
  return CnpjNormalizer.normalize(cnpj);
}
export const getDocumentType = (value: string) => {
  const document = removeNoNumeric(value);
  const hasLetter = /[a-zA-Z]/.test(value);

  return hasLetter || document.length > 11 ? 'cnpj' : 'cpf';
};
